module.exports = __webpack_public_path__ + "static/media/STOGI REFERENCE 313 TONEARM.e0ac2626.png";